import React, { useRef } from "react";
import { ReactComponent as Download } from "../images/pages/iconsV2/download.svg";
import { ReactComponent as DocumentIcon } from "../images/pages/iconsV2/document.svg";
import { ReactComponent as MarkIcon } from "../images/pages/iconsV2/mark.svg";

export type TemplateFileUploadProps = {
    file: File | null;
    onFileChange: (file: File | null) => void;
    accept?: string;
    titleWhenEmpty?: string;
    titleWhenLoaded?: string;
    subtitleWhenEmpty?: string;
    uploadButtonText?: string;
    /** Не показывать заголовок и подзаголовок (только кнопка/карточка файла) */
    compact?: boolean;
    /** Не оборачивать в div.templates-add-popup (для встраивания в существующий блок) */
    noWrapper?: boolean;
    /** Контент между заголовком и кнопкой/карточкой загрузки (например, поле названия) */
    children?: React.ReactNode;
};

function formatFileSize(file: File): string {
    return `${Math.round(file.size / 1024)} КБ`;
}

const DEFAULT_ACCEPT =
    ".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document";

export default function TemplateFileUpload({
    file,
    onFileChange,
    accept = DEFAULT_ACCEPT,
    titleWhenEmpty = "Загрузить файл docx",
    titleWhenLoaded = "Файл загружен",
    subtitleWhenEmpty = "Загрузите word файл договора с расширением .docx.",
    uploadButtonText = "Загрузить файл",
    compact = false,
    noWrapper = false,
    children,
}: TemplateFileUploadProps) {
    const inputRef = useRef<HTMLInputElement>(null);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        const chosen = files && files.length ? files[0] : null;
        onFileChange(chosen);
        e.target.value = ""; // сброс, чтобы можно было выбрать тот же файл снова
    };

    const content = (
        <>
            {!compact && (
                <div className="templates-add-popup-header ui-kit-v2">
                    <div className="H3_21_v2">
                        {file ? titleWhenLoaded : titleWhenEmpty}
                    </div>
                    {!file && subtitleWhenEmpty && (
                        <div className="Body_16_v2_secondary">
                            {subtitleWhenEmpty}
                        </div>
                    )}
                </div>
            )}
            {children}
            <input
                type="file"
                style={{ display: "none" }}
                ref={inputRef}
                accept={accept}
                onChange={handleChange}
            />
            {!file ? (
                <button
                    className="ui-kit-v2 action-button secondary"
                    onClick={() => inputRef.current?.click()}
                    type="button"
                >
                    <span className="button-text">{uploadButtonText}</span>
                    <Download className="template-upload-icon" />
                </button>
            ) : (
                <button
                    className="ui-kit-v2 template-upload-file"
                    onClick={() => inputRef.current?.click()}
                    type="button"
                >
                    <div className="template-upload-file-left">
                        <DocumentIcon className="template-upload-file-icon" />
                        <div className="template-upload-file-text">
                            <div className="template-upload-file-title">
                                {file.name}
                            </div>
                            <div className="template-upload-file-subtitle">
                                {formatFileSize(file)}
                            </div>
                        </div>
                    </div>
                    <MarkIcon className="template-upload-file-mark" />
                </button>
            )}
        </>
    );

    if (noWrapper) return content;
    return (
        <div className="templates-add-popup ui-kit-v2">
            {content}
        </div>
    );
}
